export default __webpack_public_path__ + "static/media/prague-min.794e0767.png";